module.exports = __webpack_public_path__ + "static/quickdraw-community-484773eba0e660b056b9f833c86b423e.png";